import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const EditHighlightLayer = () => {
  const [formValues, setFormValues] = useState({
    title: "",
    description: "",
    link: "",
  });
  const location = useLocation();
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );
  const promotionToEdit = location.state?.item;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [touched, setTouched] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();

  const readURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(input.target.files[0]);
    }
  };

  useEffect(() => {
    if (promotionToEdit) {
      // console.log("traderrrrrr info: ", promotionToEdit);

      setFormValues({
        title: promotionToEdit?.title,
        description: promotionToEdit?.description,
        link: promotionToEdit?.link,
      });
      setImagePreview(promotionToEdit?.icon);
      setLoading(false); // Stop loading after setting form state
    } else {
      setError("No tutor data found.");
      setLoading(false);
    }
  }, [promotionToEdit]);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      const formData = new FormData();
      formData.append("title", formValues.title);
      formData.append("description", formValues.description);
      formData.append("link", formValues.link);

      const imageInput = document.querySelector("#student-image");
      if (imageInput && imageInput.files[0]) {
        formData.append("image", imageInput.files[0]);
      }

      // console.log(
      //   "REACT_APP_INSTITUTION_BASEURL:: ",
      //   process.env.REACT_APP_INSTITUTION_BASEURL
      // );
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/edit-promotion/${promotionToEdit._id}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
          "Content-Type": "multipart/form-data",
        }
      );
      if (response.status === 200) {
        setSnackbarMessage("Updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/promotion-list");
        }, 2000);
      }
    } catch (err) {
      setLoading(false);

      // Check for 400 status error
      if (err.response && err.response.status === 400) {
        setSnackbarMessage("Please fill out all required fields...");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Failed to update. Please try again");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/trader-list");
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        
          
            <div className="card h-100">
              <div className="card-body p-24">
                <form onSubmit={handleFormSubmit}>
                  <div className="mb-20">
                    <label
                      htmlFor="title"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Highlight Image
                      <span className="text-danger-600">*</span>
                    </label>
                    <div className="avatar-upload">
                      <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                        {/* File input hidden using CSS */}
                        <input
                          type="file"
                          id="student-image"
                          accept="image/*"
                          className="d-none" // This hides the file input
                          onChange={readURL}
                        />
                        <label
                          htmlFor="student-image" // Bind label to file input
                          className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                        >
                          <Icon icon="solar:camera-outline" className="icon" />
                        </label>
                      </div>
                      <div className="avatar-preview">
                        <div
                          id="imagePreview"
                          style={{
                            backgroundImage: `url(${imagePreview})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="title"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Title
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="title"
                      required
                      placeholder="Enter Title"
                      value={formValues.title}
                      onChange={(e) => {
                    
                        const value = e.target.value;
    
                        if (value === "" || value.trim() !== "") {
                          setFormValues({
                            ...formValues,
                            title: value,
                          });
                        }
                      }}
                      onBlur={() => setTouched(true)} // Mark as touched when losing focus
                    />
                    
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="title"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Description
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="description"
                      required
                      placeholder="Enter Title"
                      value={formValues.description}
                      onChange={(e) => {
                    
                        const value = e.target.value;
    
                        if (value === "" || value.trim() !== "") {
                          setFormValues({
                            ...formValues,
                            description: value,
                          });
                        }
                      }}
                      onBlur={() => setTouched(true)} // Mark as touched when losing focus
                    />
                    
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="title"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Link
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="link"
                      required
                      placeholder="Enter Title"
                      value={formValues.link}
                      onChange={(e) => {
                    
                        const value = e.target.value;
    
                        if (value === "" || value.trim() !== "") {
                          setFormValues({
                            ...formValues,
                            link: value,
                          });
                        }
                      }}
                      onBlur={() => setTouched(true)} // Mark as touched when losing focus
                    />
                    
                  </div>

                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="button"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                      onClick={() => navigate("/promotion-list")}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                      // onClick={handleFormSubmit}
                    >
                      {loading && (
         <div className="loader-container" style={styles.loaderContainer}>
                                              <CircularProgress />
                                            </div>
                                          )}
                                            Save
                    </button>
                  </div>
                </form>
              </div>
            
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditHighlightLayer;
